import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';

@Component({
  selector: 'app-editar-saldo',
  templateUrl: './editar-saldo.component.html',
  styleUrls: ['./editar-saldo.component.scss'],
})
export class EditarSaldoComponent implements OnInit {
  registerForm: UntypedFormGroup;
  muestraBtnGuardar=true;
  constructor(
    private empresaSvc: EmpresaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditarSaldoComponent>,
    private alertify: AlertifyService
  ) {
    console.log(this.data);
  }

  ngOnInit(): void {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      valorEdicion: new UntypedFormControl('', [Validators.required]),
      descripcion: new UntypedFormControl(''),
    });
    this.registerForm.get('id')?.setValue(this.data);
  }

  guardar() {
    this.muestraBtnGuardar=false;
    console.log('guardar saldo');
    console.log(this.registerForm.value);

    //aqui mando a editar
    this.empresaSvc.cambiarSaldo(this.registerForm.value).subscribe((res) => {
      console.log('resultado Editar: ', res);
      if (res != -1) {
        this.alertify.success('Saldo actualizado');
        this.dialogRef.close(true);
      } else {
        this.alertify.error('El saldo no se puede actualizar');
      }
    });
  }
}
